import React from 'react';
import { useNavigate } from 'react-router-dom';
import LazySection from './LazySection';

const StackCards = () => {
  const navigate = useNavigate();

  const serviceCards = [
    {
      imageSrc: "01.png",
      imageAlt: "Fat Loss Program",
      title: "Fat Loss Program:$28.99",
      description: "Want to lose fat? fit better in clothes? want to transform? want to be a better version of yourself? Behzad will personally design your whole program based upon your physical condition.",
      features: [
        "One Time Personalized Diet Plan",
        "One Time Personalized Workout Plan",
        "One Time Personalized Supplement Guidance",
        "One Time Video Consultation"
      ],
      imagePosition: "left",
      hasLearnMore: true,
      onClick: () => navigate("/onboarding")
    },
    {
      imageSrc: "02.png",
      imageAlt: "Online Coaching",
      title: "Online Personal Coaching: $90.99 / Month",
      description: "Want to lose fat? build muscle? fit better in clothes? want to lift heavy? want to transform? want to be a better version of yourself? One stop solution for everything, Behzad will personally help you in winning what you want.",
      features: [
        "Personalized Diet Plan",
        "Personalized Workout Plan", 
        "Personalized Supplement Guidance",
        "Three 15 Minutes Video Meetings Per Week",
        "One Physical Workout Session Per Month"
      ],
      imagePosition: "right",
      hasLearnMore: true,
      onClick: () => navigate("/online-coaching-signup")
    },
    {
      imageSrc: "03.png",
      imageAlt: "Power-lifting & Strength",
      title: "Online Power-lifting & Strength Coaching: $90.99  / Month",
      description: "Want to compete in power-lifting? want to lift heavy? want to increase your PRs? want to be a stronger & rigid version of yourself? Behzad and his team will personally help you in becoming the strongest version of yourself.",
      features: [
       
        "Personalized Workout Plan",
        "Personalized Supplement Guidance", 
        "One 30 Minutes Video Meetings Per Week",
        "One Physical Workout Session Per Month",
      ],
     imagePosition: "left",
      hasLearnMore: true,
      onClick: () => navigate("/powerlifting-signup")
    },
    {
      imageSrc: "behzad_bhai_cconsult 1.png",
      imageAlt: "One Time Video Consultation: $7.99(30 Minutes)",
      title: "One Time Video Consultation: $7.99(30 Minutes)",
      description: "It is meant for people  who need more frequent contact with Behzad, and require more specific and prolonged knowledge transfer. You can take notes, discuss ideas, review blood work, adjust their diet, training, supplementation, Etc.",
      features: [
        " 30 Minutes Discussion",
       
      ],
      imagePosition: "right",
      hasLearnMore: true,
      onClick: () => navigate("/consultation-signup")
    },
    {
      imageSrc: "doctor1.jpg",
      imageAlt: "Dr. Nouman Consultation: $10.99 (30 Minutes)",
      title: "One Time Video Consultation - Dr. Nouman: $10.99 (30 Minutes)",
      description: "It is meant for people who need more frequent contact with Dr. Nouman, and require more specific and prolonged knowledge transfer. You can take notes, PED discussion, review blood work, adjust their diet, training, supplementation, Etc.",
      features: [
        "PED Discussion",
        "Blood Work Review",
        "Blood Work Regulation",
        "Injury Discussion",
        "Hormone Regulation"
      ],
      imagePosition: "left", 
      hasLearnMore: true,
      onClick: () => navigate("/dr-nouman-signup")
    },
    {
      imageSrc: "02.png",
      imageAlt: "Bulk Program: $20.99",
      title: "Bulk Program: $28.99",
      description: "Want to gain muscle? fit better in clothes? want to transform? want to be a better version of yourself? Behzad will personally design your whole program based upon your physical condition.",
      features: [
        "One Time Personalized Diet Plan",
        "One Time Personalized Workout Plan",
        "One Time Personalized Supplement Guidance",
        "One Time Video Consultation",
      ],
      imagePosition: "left", 
      hasLearnMore: true,
      onClick: () => navigate("/bulk")
    }
    //  {
    //   imageSrc: "ali_bhai.png",
    //   imageAlt: "Dr. Nouman Consultation: $10.99 (30 Minutes)",
    //   title: "Promote your Brand",
    //   description: "It is meant for people who need more frequent contact with Dr. Nouman, and require more specific and prolonged knowledge transfer. You can take notes, PED discussion, review blood work, adjust their diet, training, supplementation, Etc.",
    //   features: [
    //     "PED Discussion",
    //     "Blood Work Review",
    //     "Blood Work Regulation",
    //     "Injury Discussion",
    //     "Hormone Regulation"
    //   ],
    //   imagePosition: "left", 
    //   hasLearnMore: true,
    //   onClick: () => navigate("/dr-nouman-signup")
    // }
  ];

  return (
    <div id="online-coaching-section" className="px-4 md:px-8 lg:px-16 pt-10 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="space-y-24">
          {serviceCards.map((card, index) => (
            <LazySection key={index} animationType="slide" delay={index * 150}>
              <div className={`flex flex-col ${card.imagePosition === 'right' ? 'lg:flex-row' : 'lg:flex-row-reverse'} items-center gap-12 lg:gap-20 bg-white rounded-2xl p-8 border border-gray-200 shadow-md`}>
                {/* Content Side */}
                <div className="flex-1 max-w-lg">
                  <h2 className="text-3xl md:text-4xl lg:text-[34px] font-bold text-[#2B4C7E] mb-6 leading-tight">
                    {card.title}
                  </h2>
                  
                  <p className="text-gray-600 text-base md:text-lg leading-relaxed mb-8">
                    {card.description}
                  </p>

                  {/* Features List */}
                  <div className="space-y-4 mb-10">
                    {card.features.map((feature, idx) => (
                      <div key={idx} className="flex items-center gap-3">
                        <div className="w-5 h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0" style={{borderColor:'#fc0100'}}>
                          <div className="w-2 h-2 rounded-full" style={{backgroundColor:'#fc0100'}}></div>
                        </div>
                        <span className="text-gray-700 text-sm md:text-base">
                          {feature}
                        </span>
                      </div>
                    ))}
                  </div>

                  {/* Learn More Button */}
                  {card.hasLearnMore && (
                    <button 
                      onClick={card.onClick}
                      className="bg-[#fc0100] text-white px-6 py-2 rounded-full font-medium hover:bg-red-700 transition-colors"
                    >
                      LEARN MORE
                    </button>
                  )}
                </div>

                {/* Image Side */}
                <div className="flex-1 flex justify-center">
                  <div className="relative">
                    <img
                      src={card.imageSrc}
                      alt={card.imageAlt}
                      className="w-full max-w-[400px] h-[300px] md:h-[400px] object-cover rounded-2xl shadow-lg border border-gray-200"
                      loading="lazy"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent rounded-2xl"></div>
                  </div>
                </div>
              </div>
            </LazySection>
          ))}
        </div>
      </div>
    </div>
  );
};

export default StackCards;